import createAction from '../services/create-action';

export const SHOW_MESSAGE = 'message/SHOW';
export const showMessage = createAction(SHOW_MESSAGE, (content, type = 'info') => ({ content, type }));



// WEBPACK FOOTER //
// ./app/actions/show-message.js